/**
 * gw-multilevel-navbar
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module dependencies
// import './_dropdown';

// Default Image import
import './gw_mono_0_0.png';

// Module styles
import './_gw-multilevel-navbar.js';

// Module styles
import './_gw-multilevel-navbar.scss';

// Module template
import './_gw-multilevel-navbar.twig';
import './_gw-multilevel-navbar-macro.twig';

export const name = 'gw-multilevel-navbar';

export const defaults = {
  dummyClass: 'js-gw-multilevel-navbar-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) { }

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { gwMultilevelNavbar = {} }) {
  // Find our component within the DOM
  const $gwMultilevelNavbar = $('.gw-multilevel-navbar', $context);
  // Bail if component does not exist
  if (!$gwMultilevelNavbar.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...gwMultilevelNavbar,
  };
  // An example of what could be done with this component
  $gwMultilevelNavbar.addClass(settings.dummyClass);
}

export default enable;

/*
 * Override bootstrap js to allow all navbar links to work.
 */
// $('.navbar a[href]').click(function () {
//   if (this.href) {
//     location.href = this.href;
//   }
// });




// Scroll to 95 and add the fixed-top class.
// Toggle the hidden navbar brand button.
// Copy the call to action button into the nav.
$(window).on('scroll', function () {
  if ($(window).scrollTop() >= 95 && !$('nav.gw-multilevel-navbar').hasClass('fixed-top')) {
    $("nav.gw-multilevel-navbar").addClass('fixed-top');
    $("#block-searchbloxsearch").addClass('fixed-top');
    $("a.navbar-brand").toggle();
    $(".cta-btn").clone().appendTo("nav.gw-multilevel-navbar .nav-group");
    // $("div#block-breadcrumbs").toggle();
    $("#nav-search-form").insertAfter("nav.gw-multilevel-navbar");
  }
  // Undo everything if unscrolled.
  else if ($(window).scrollTop() < 95 && $('nav.gw-multilevel-navbar').hasClass('fixed-top')) {
    $("nav.gw-multilevel-navbar").removeClass('fixed-top');
    $("#block-searchbloxsearch").removeClass('fixed-top');
    $("a.navbar-brand").toggle();
    $("nav.gw-multilevel-navbar .cta-btn").detach();
    // $("div#block-breadcrumbs").toggle();
  }
});

